import * as Scrivito from "scrivito";
import metadataAttributes from "../_metadataAttributes";
import defaultPageAttributes from "../_defaultPageAttributes";

const Root = Scrivito.provideObjClass("Root", {
  attributes: {
    ...defaultPageAttributes,
    body: ["widgetlist", { only: "SectionContentWidget" }],
    ...metadataAttributes,
  },
  extractTextAttributes: ["body"],
});

export default Root;
